if (!customElements.get('card-color-swatches')) {
  customElements.define(
    'card-color-swatches',
    class CardColorSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        if (!this.card) return;

        this.image = this.card.querySelector('.card__media img');
        this.links = this.card.querySelectorAll('.card__heading a');
        this.selected = null;
        this.preloaded = false;

        if (this.image) {
          this.originalImage = {
            src: this.image.getAttribute('src'),
            srcset: this.image.getAttribute('srcset'),
          };
        }

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('pointerover', this.onPointerOver.bind(this));
        this.addEventListener('pointerout', this.onPointerOut.bind(this));
        this.card.addEventListener('pointerenter', this.preload.bind(this), { once: true });
      }

      onClick(event) {
        const swatch = event.target.closest('button.card-swatch');
        if (!swatch) return;

        event.preventDefault();
        this.preload();
        if (this.selected) this.selected.setAttribute('aria-pressed', 'false');
        this.selected = swatch;
        swatch.setAttribute('aria-pressed', 'true');
        this.links.forEach((link) => link.setAttribute('href', swatch.dataset.url));
        this.card
          .querySelectorAll('[data-product-url]')
          .forEach((opener) => opener.setAttribute('data-product-url', swatch.dataset.url));
        this.showImage(swatch);
      }

      onPointerOver(event) {
        if (event.pointerType !== 'mouse') return;
        const swatch = event.target.closest('button.card-swatch');
        if (swatch) this.showImage(swatch);
      }

      onPointerOut(event) {
        if (event.pointerType !== 'mouse') return;
        if (event.target.closest('button.card-swatch')) this.showImage(this.selected);
      }

      // Falls back to the selected colour, then to the product's own image, when a colour has no image.
      showImage(swatch) {
        if (!this.image) return;

        let source = null;
        if (swatch && swatch.dataset.image) {
          source = swatch;
        } else if (this.selected && this.selected.dataset.image) {
          source = this.selected;
        }

        if (source) {
          this.image.removeAttribute('srcset');
          this.image.setAttribute('src', source.dataset.image);
        } else {
          if (this.originalImage.srcset) this.image.setAttribute('srcset', this.originalImage.srcset);
          this.image.setAttribute('src', this.originalImage.src);
        }
      }

      preload() {
        if (this.preloaded) return;
        this.preloaded = true;
        this.querySelectorAll('button.card-swatch[data-image]').forEach((swatch) => {
          new Image().src = swatch.dataset.image;
        });
      }
    }
  );
}
